module.exports = flarum.core.compat['helpers/humanTime'];